/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { Horizontal } from "./social-share";

export function HorizontalGrey(props) {
  return <Horizontal grey {...props} />;
}
